import { Person } from '../types';
import { WorkLocation } from 'features/static-data';

type EndorserPreview = Person & {
  rating?: number;
  endorsementDate?: string;
};

export class ProfilePreviewModel {
  constructor(private readonly _data: EndorserPreview) {}

  get id(): string {
    return this._data.id;
  }

  get fullName(): string {
    return this._data.fullName || '';
  }

  get photo(): string {
    return this._data.photo || '';
  }

  get profileHeadline(): string {
    return this._data.profileHeadline as string;
  }

  get workLocation(): WorkLocation {
    return this._data.workLocation as WorkLocation;
  }

  get rating(): number | undefined {
    return this._data.rating;
  }

  get endorsementDate(): string | undefined {
    return this._data.endorsementDate;
  }
}
